import { Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";

import type { IconWithTooltipProps } from "./IconWithTooltip.decl";

export const IconWithTooltip = ({
  color = "text-foreground",
  icon: IconComponent,
  tooltip,
  dataTest,
  size = 20,
}: IconWithTooltipProps) => {
  if (!IconComponent) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger
        data-test={dataTest}
        // Icon-only trigger: the tooltip text is not the accessible name, so
        // name the control explicitly when the tooltip is a plain string.
        aria-label={typeof tooltip === "string" ? tooltip : undefined}
        render={<IconComponent className={color} width={size} height={size} />}
      />
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
};
